<template>
  <div class="row">
    <div class="col-12 col-sm-6 col-md-6 col-lg-4 col-xl-4">
      <div class="form-group has-label">
        <label>{{ $t('inventory.suppliers') }}: *</label>
        <br />
        <el-select
          @change="
            selectAllFromSelect('model.providers_id', providers),
              getCategoryByProviders()
          "
          collapse-tags
          clearable
          filterable
          multiple
          class="select-primary custom-width-select shadow-sm required-providers"
          size="large"
          v-model="model.providers_id"
          :placeholder="`${$t('common_words.select')}...`"
        >
          <el-option
            v-for="(option, index) in providers"
            class="select-primary selected-all"
            :value="option.id"
            :label="`${option.name}${
              option.last_name ? '-' + option.last_name : ''
            }${option.nit ? '-' + option.nit : ''}...`"
            :key="option.id"
          ></el-option>
        </el-select>
      </div>
    </div>
    <div class="col-12 col-sm-6 col-md-6 col-lg-4 col-xl-4">
      <div class="form-group has-label">
        <label>{{ $t('inventory.article_category') }}: *</label>
        <br />
        <el-select
          @change="
            selectAllFromSelect(
              'model.article_categories_id',
              articleCategoriesByProviders
            ),
              getArticleByCategory()
          "
          collapse-tags
          clearable
          filterable
          multiple
          class="select-primary custom-width-select shadow-sm required-articleCategories"
          size="large"
          v-model="model.article_categories_id"
          :placeholder="`${$t('common_words.select')}...`"
        >
          <el-option
            v-for="(option, index) in articleCategoriesByProviders"
            class="select-primary selected-all"
            :value="option.id"
            :label="option.name"
            :key="option.id + option.name"
          ></el-option>
        </el-select>
      </div>
    </div>
    <div class="col-12 col-sm-6 col-md-6 col-lg-4 col-xl-4">
      <div class="form-group has-label">
        <label>{{ $t('inventory.articles') }}: *</label>
        <br />
        <el-select
          @change="selectAllFromSelect('model.articles_id', aticleByCategory)"
          collapse-tags
          clearable
          filterable
          multiple
          class="select-primary custom-width-select shadow-sm required-articles"
          size="large"
          v-model="model.articles_id"
          :placeholder="`${$t('common_words.select')}...`"
        >
          <el-option
            v-for="(option, index) in aticleByCategory"
            class="select-primary selected-all"
            :value="option.id"
            :label="option.name"
            :key="index + option.id + option.name"
          ></el-option>
        </el-select>
      </div>
    </div>
  </div>
</template>
<script>
import { Axios } from 'src/class/Axios.js';
import { isset } from 'src/util/Util';
import i18n from 'src/i18n';
import MixinAlert from 'src/mixins/mixin-alert';
import MixinForm from 'src/mixins/forms/mixin-form';
import MixinLoading from 'src/mixins/mixin-loading';
import MixinPermissions from 'src/util/mixinPermissions';
import MixinValidations from 'src/mixins/forms/mixin-validations.js';

export default {
  components: {},
  data() {
    return {
      providers: [],
      articles: [],
      providerArticles: [],
      articleCategories: [],
      articleCategoriesByProviders: [],
      aticleByCategory: [],
      isActiveCategory: false,
      isActiveArticle: false,
      model: {
        providers_id: [],
        providers_name: [],
        article_categories_id: [],
        article_categories_name: [],
        articles_id: [],
        articles_name: [],
      },
    };
  },
  computed: {},
  watch: {
    '$i18n.locale': ['getSelectAll'],
  },
  mixins: [
    MixinPermissions,
    MixinForm,
    MixinAlert,
    MixinLoading,
    MixinValidations,
  ],
  methods: {
    getSelectAll() {
      this.providers = this.concatAll(this.providers.splice(1));
    },
    getCategoryByProviders() {
      if (isset(this.model.providers_id)) {
        const providersSelect = this.providers.filter((provider) =>
          this.model.providers_id.includes(provider.id)
        );

        this.providerArticles = providersSelect
          .map((provider) => provider.articles)
          .flat();

        const articleCategoryIds = [
          ...new Set(
            this.providerArticles.map((article) => article.article_category_id)
          ),
        ];

        this.articleCategoriesByProviders = this.articleCategories.filter(
          (category) => articleCategoryIds.includes(category.id)
        );

        this.model.article_categories_id =
          this.model.article_categories_id.filter((id) =>
            articleCategoryIds.includes(id)
          );

        this.articleCategoriesByProviders = this.concatAll(
          this.articleCategoriesByProviders
        );
        this.getArticleByCategory();
      } else {
        this.model.article_categories_id = [];
        this.model.articles_id = [];
      }
    },
    getArticleByCategory() {
      if (isset(this.model.article_categories_id)) {
        this.aticleByCategory = this.providerArticles.filter((article) =>
          this.model.article_categories_id.includes(article.article_category_id)
        );

        const articleIds = [
          ...new Set(this.aticleByCategory.map((article) => article.id)),
        ];

        this.model.articles_id = this.model.articles_id.filter((id) =>
          articleIds.includes(id)
        );
        this.aticleByCategory = this.concatAll(this.aticleByCategory);
      } else {
        this.model.articles_id = [];
      }
    },
    getNameOfData(dataMain, options) {
      const others = [];
      dataMain.forEach((element) => {
        const isFind = options.find((item) => item.id === element);
        if (isFind) others.push(isFind.name);
      });

      return others;
    },
    getNameAndDataOfProviders(dataMain, options) {
      const others = [];
      dataMain.forEach((element) => {
        const isFind = options.find((item) => item.id === element);
        if (isFind) {
          const providerInfo = `${isFind.first_name}${
            isFind.last_name ? '-' + isFind.last_name : ''
          }${isFind.nit ? '-' + isFind.nit : ''}`;
          others.push(providerInfo);
        }
      });

      return others;
    },
    validate() {
      return this.$validator.validateAll().then((isValid) => {
        if (isValid) {
          if (this.model.providers_id.length == 0) {
            return this.validationInputsRequired('providers');
          } else if (this.model.article_categories_id.length == 0) {
            return this.validationInputsRequired('articleCategories');
          } else if (this.model.articles_id.length == 0) {
            return this.validationInputsRequired('articles');
          }
          this.model.providers_name = this.getNameAndDataOfProviders(
            this.model.providers_id,
            this.providers
          );

          this.model.article_categories_name = this.getNameOfData(
            this.model.article_categories_id,
            this.articleCategoriesByProviders
          );
          this.model.articles_name = this.getNameOfData(
            this.model.articles_id,
            this.aticleByCategory
          );
          this.$emit('on-validated', this.model);

          return isValid;
        }
      });
    },
  },
  created() {
    if (this.isCreate() || this.isUpdate()) {
      Promise.all([
        Axios.getMasters('inventory/providerheader'),
        Axios.getMasters('inventory/article'),
        Axios.getMasters('inventory/articlecategory'),
      ])
        .then(
          ([
            responseProviders,
            responseArticles,
            responseArticleCategories,
          ]) => {
            this.providers = this.concatAll(responseProviders.data.data);
            this.articles = responseArticles.data.data;
            this.articleCategories = responseArticleCategories.data.data;
            const editForm = sessionStorage.getItem('editForm');
            if (this.isUpdate() && editForm) {
              const { provider_headers, article_categories, articles } =
                JSON.parse(editForm);

              this.model = {
                ...this.model,
                providers_id: provider_headers.map((provider) => provider.id),
                article_categories_id: article_categories.map(
                  (article_category) => article_category.id
                ),
                articles_id: articles.map((article) => article.id),
              };
              this.getCategoryByProviders();
              this.getArticleByCategory();
            }
            setTimeout(() => {
              this.showHideLoading();
            }, 1000);
          }
        )
        .catch((error) => this.showMessageErrors(error));
    } else this.showHideLoading();
  },
};
</script>
